import React, { FC } from "react";
import cx from "classnames";

import { ButtonVariant } from "../Button/Button.types";

import "./IconButton.scss";

export type IconButtonProps = {
  onClick?: () => void;
  variant?: ButtonVariant;
  size: string;
  disabled?: boolean;
  className?: string;
  isCircle?: boolean;
};

export const IconButton: FC<IconButtonProps> = ({
  onClick,
  variant = "primary",
  size = "md",
  disabled,
  className,
  children,
  isCircle,
}) => {
  return (
    <button
      className={cx(
        { circle: isCircle, disabled },
        "button-base icon-button-base",
        variant,
        size,
        className
      )}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
